import { STREAK_CYCLE, STREAK_PET_DAY, STREAK_PET_ITEM, } from '../data/streak.js';
/** What the `day`-th day of a streak pays (from 1): its place in the cycle, and the fox on the 7th. */
export function streakReward(day) {
    const index = (Math.max(1, Math.floor(day)) - 1) % STREAK_CYCLE.length;
    const cycle = STREAK_CYCLE[index] ?? { gold: 0, items: [] };
    const items = [...cycle.items];
    if (day === STREAK_PET_DAY)
        items.push({ templateId: STREAK_PET_ITEM, quantity: 1 });
    return { gold: cycle.gold, items };
}
//# sourceMappingURL=streak.js.map